/**
 * Resolve a configured websocket URL.
 *
 * Absolute values (ws://host:port/path, wss://...) are returned unchanged so
 * local development with .env.local keeps working. Values starting with "/"
 * are treated as same-origin paths and expanded against the current page, so
 * a single image works behind any host/TLS terminator:
 *   https://example.com + /ws/system -> wss://example.com/ws/system
 */
export function resolveWsUrl(value?: string): string | undefined {
  if (!value || !value.startsWith("/")) {
    return value;
  }
  const protocol = window.location.protocol === "https:" ? "wss" : "ws";
  return `${protocol}://${window.location.host}${value}`;
}
